import { Module } from 'vuex'
import { categories as categoriesApi, RequestItemBag } from '@/api'

export const categories: Module<{}, {}> = {
  namespaced: true,

  actions: {
    async listing(_, query: RequestItemBag = {}) {
      return await categoriesApi.go(query['page'] ?? 1, query['query'] ?? {})
    },
    async all() {
      return await categoriesApi.all()
    },
  },
}
